import { FiltersIcon, SearchIcon } from 'components/Icons/Icons';
import InputText from 'components/InputText/InputText';
import { AttributeMap } from 'hooks/useBreakerGallery';
import React from 'react';
import { Attribute } from 'types/Breaker';
import Filters from './Filters';

type FiltersViewProps = {
  search: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  activeFilters: Attribute[];
  attributeMap: AttributeMap;
  setFilter: (attribute: Attribute) => void;
  removeFilter: (attribute: Attribute) => void;
};

export const FiltersView = ({
  search,
  onSearch,
  activeFilters,
  attributeMap,
  setFilter,
  removeFilter,
}: FiltersViewProps) => (
  <nav className="col-md-4 pt-0 pb-3 navbar navbar-expand-md">
    <h3 className="d-none d-md-block">Search</h3>
    <div className="search mt-3">
      <SearchIcon />
      <InputText
        placeholder="Search"
        type="text"
        id="search"
        value={search}
        onChange={(e) => onSearch(e)}
      />
    </div>
    <button
      id="filter"
      className="d-block d-md-none btn btn-sm btn-secondary w-100"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#filterOffcanvasMd"
      aria-controls="filterOffcanvasMd"
    >
      <FiltersIcon />
      <span>Filters</span>
    </button>
    <div
      className="offcanvas offcanvas-end"
      id="filterOffcanvasMd"
      aria-labelledby="filterOffcanvasMdLabel"
    >
      <Filters
        activeFilters={activeFilters}
        attributeMap={attributeMap}
        setFilter={setFilter}
        removeFilter={removeFilter}
      />
    </div>
  </nav>
);
